export enum EOperationProofType {
  ProductType = 0,
  ProductQuantity = 1,
  TransportType = 2,
  TransportDistance = 3,
  VehicleDays = 4,
  VehicleCount = 5,
  VehicleType = 6,
  EnergyType = 7
}

export const ProofTypeLabelKeys: Record<EOperationProofType, string> = {
  [EOperationProofType.ProductType]: 'proof_type_product_type',
  [EOperationProofType.ProductQuantity]: 'proof_type_product_quantity',
  [EOperationProofType.TransportType]: 'proof_type_transport_type',
  [EOperationProofType.TransportDistance]: 'proof_type_transport_distance',
  [EOperationProofType.VehicleDays]: 'proof_type_vehicle_days',
  [EOperationProofType.VehicleCount]: 'proof_type_vehicle_count',
  [EOperationProofType.VehicleType]: 'proof_type_vehicle_type',
  [EOperationProofType.EnergyType]: 'proof_type_energy_type'
};

export const LabelKeyToProofType: Record<string, EOperationProofType> = {
  proof_type_product_type: EOperationProofType.ProductType,
  proof_type_product_quantity: EOperationProofType.ProductQuantity,
  proof_type_transport_type: EOperationProofType.TransportType,
  proof_type_transport_distance: EOperationProofType.TransportDistance,
  proof_type_vehicle_days: EOperationProofType.VehicleDays,
  proof_type_vehicle_count: EOperationProofType.VehicleCount,
  proof_type_vehicle_type: EOperationProofType.VehicleType,
  proof_type_energy_type: EOperationProofType.EnergyType
};
